function isValidNumber(value) {
  return /^-?\d*\.?\d*$/.test(value);
}

export default isValidNumber;
//# sourceMappingURL=isValidNumber.js.map
